export default __webpack_public_path__ + "static/media/5.blur.41f48980.jpeg";